import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">
          {t('not_found.title')}
        </h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          {t('not_found.description')}
        </p>
        <button
          onClick={() => navigate('/')}
          className="mt-8 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors"
        >
          {t('not_found.back_home')}
        </button>
      </div>
    </div>
  );
}